export default __webpack_public_path__ + "0a5ac7f9f09819355f1f6f0ca8ef1506.png";